<template>
  <payment-waiting-screen-component
    v-if="paymentWaitingScreen.state.visible"
    :amount="paymentWaitingScreen.state.amount"
    :cancellable="paymentWaitingScreen.state.cancellable"
    :status="paymentWaitingScreen.state.status"
    :error-message="paymentWaitingScreen.state.errorMessage"
    @cancel="paymentWaitingScreen.triggerCancel"
  />
</template>

<script setup lang="ts">
import { usePaymentWaitingScreen } from '@/composables/usePaymentWaitingScreen'
import PaymentWaitingScreenComponent from '@/modules/checkout/PaymentWaitingScreen.vue'

const paymentWaitingScreen = usePaymentWaitingScreen()
</script>
